export const MODULE_VERTICAL_SIGNING = "verticalSigning"
export const MODULE_HORIZONTAL_SIGNING = "horizontalSigning"
export const MODULE_EQUIPMENT = "equipment"
export const MODULES_CITY = [MODULE_EQUIPMENT, MODULE_HORIZONTAL_SIGNING, MODULE_VERTICAL_SIGNING]